// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAEQ8WvmG05-1QM1_oKJIVXtzbzLoxgkYE",
  authDomain: "oliu-c9c7a.firebaseapp.com",
  projectId: "oliu-c9c7a",
  storageBucket: "oliu-c9c7a.appspot.com",
  messagingSenderId: "342346628765",
  appId: "1:342346628765:web:1f439d267c469701489e74",
};

// Initialize Firebase
export default initializeApp(firebaseConfig);
